export const API_BASE_URL = process.env.REACT_APP_LOGSHEET_API;

export const ENDPOINTS = {
    AUTH: {
        LOGIN: '/auth/login',
        REGISTER: '/auth/register',
        FORGOT_PASSWORD: '/auth/register',
        UPDATE_PASSWORD: '/auth/login'
    },
    USER: {
        FETCH_USERS: '/users',
        ADD_USER: '/users',
        UPDATE_USER: '/users',
        FETCH_PLANT_USERS: '/users',
        FETCH_PLANT_HODS: '/users',
        FETCH_OWNERS: '/users'
    },
    EQUIPMENT: {
        FETCH_EQUIPMENTS: '/equipments',
        ADD_EQUIPMENT: '/equipments',
        UPDATE_EQUIPMENT: '/equipments',
        FETCH_LIVE_LOCATION: '/live-location',
    },
    REPORT: {
        GENERATE_REPORT: '/reports/equipment'
    },
    OPTIONS: {
        FETCH_COST_CENTER_OPTIONS: '/cost-center-options',
        FETCH_VEHICLE_HIRING_PURPOSE: '/vehicle-hiring-purpose',
        FETCH_COMPANYWISE_EQUIPMENTS: '/companywise-equipments',
    },
    LOG_ENTRY: {
        FETCH_LOG_ENTRIES: '/log-entries',
        SYNC_LOG_ENTRIES: '/log-entries',
        UPDATE_LOG_ENTRY: '/log-entries',
        FETCH_VEHICLE_ROUTE: '/vehicle-route',
    },
}

export const REQUEST_TYPES = {
    LOGIN: 'login',
    REGISTER: 'register',
    FORGOT_PASSWORD_MAIL: 'forgot_password_send_mail',
    UPDATE_FIRST_PW: 'update_first_login_password',
    FETCH_USERS: 'get_users',
    ADD_USER: 'add_user',
    UPDATE_USER: 'update_user',
    FETCH_PLANT_USERS: 'get_plant_users',
    FETCH_PLANT_HODS: 'get_plant_hods',
    FETCH_OWNERS: 'get_owners',
    ADD_EQUIPMENT: 'add_equipment',
    FETCH_EQUIPMENTS: 'get_equipments',
    UPDATE_EQUIPMENT: 'update_equipment',
    GENERATE_EQUIPMENT_REPORT: 'generate_equipment_report',
    FETCH_COST_CENTER_OPTIONS: 'get_cost_center_options',
    FETCH_VEHICLE_HIRING_PURPOSE: 'get_vehicle_hiring_purpose',
    FETCH_COMPANYWISE_EQUIPMENTS: 'get_companywise_equipments',
    FETCH_LOG_ENTRIES: 'get_log_entries',
    SYNC_LOG_ENTRIES: 'sync_log_entries',
    UPDATE_LOG_ENTRY: 'update_log_entry',
    FETCH_LIVE_LOCATION: 'get_live_location',
    FETCH_VEHICLE_ROUTE: 'get_vehicle_route',
}

export const MESSAGES = {
    SUCCESS: {
        SYNC_LOG_ENTRIES: 'VTS sync triggered successfully',
        LOGIN: 'User logged in successfully',
        REGISTER: 'User registered successfully',
        FORGOT_PASSWORD_MAIL: 'Send forgot password mail successfully',
        UPDATE_FIRST_PW: '"Password updated! Please login with your new password."',
        FETCH_USERS: 'Fetch users list successfully',
        ADD_USER: 'User added successfully',
        UPDATE_USER: 'Update user profile successfully',
        ADD_EQUIPMENT: 'Equipment Added successfully',
        FETCH_EQUIPMENTS: 'Fetch equipments list successfully',
        UPDATE_EQUIPMENT: 'Update equipment successfully',
        GENERATE_REPORT: 'Generate report successfully',
        FETCH_LOG_ENTRIES: 'Fetch log entries successfully',
        UPDATE_LOG_ENTRY: 'Log entry updated successfully',
        FETCH_LIVE_LOCATION: 'Live location fetched successfully',
        FETCH_VEHICLE_ROUTE: 'Route opened in Google Maps',

    },
    ERROR: {
        SYNC_LOG_ENTRIES: 'Failed to trigger VTS sync',
        SYNC_LOG_ENTRIES_TIMEOUT: 'VTS is taking too long to respond. Please try again in a moment.',
        LOGIN: 'Invalid credentials',
        REGISTER: 'Failed to register user',
        FORGOT_PASSWORD_MAIL: 'Email not found. Please enter registered email',
        UPDATE_FIRST_PW: 'Failed to update first login password',
        FETCH_USERS: 'Failed to fetch users',
        ADD_USER: 'Failed to add user',
        UPDATE_USER: 'Failed to update users',
        ADD_EQUIPMENT: 'Failed to add equipment',
        FETCH_EQUIPMENTS: 'Failed to fetch equipments',
        UPDATE_EQUIPMENT: 'Failed to update equipments',
        GENERATE_REPORT: 'Failed to generate report',
        FETCH_LOG_ENTRIES: 'Failed to fetch log entries',
        UPDATE_LOG_ENTRY: 'Failed to update log entry',
        FETCH_LIVE_LOCATION: 'Could not fetch live location for this vehicle',
        LIVE_LOCATION_NO_VEHICLE: 'This record has no vehicle number',
        FETCH_VEHICLE_ROUTE: 'Could not fetch route for this vehicle and date',
        VEHICLE_ROUTE_NO_DATA: 'This record is missing a vehicle number or date',
    }
}